<template>
  <div class="generalmapcontainer">
    <div id='container'></div>
    <div class="floatDivBoxs">
      <!--<div class="titlebox"><h2>全部（<span>556</span>）</h2></div>-->
      <!--mapnavValue 默认 显示路径 （数组值）-->
      <el-cascader
        :key="keyValue"
        ref="mapnav"
        v-model="mapnavValue"
        :options="options"
        :props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
        :show-all-levels="false"
        popper-class="maptype"
        @change="handleChange"></el-cascader>
      <ul>
        <li v-for="(item, index) in markerArr" :key="index" @click="listpoint(item)">
          <h2 :style="{backgroundImage: geticon(item.icon) }">{{item.title}}</h2>
          <p>地址：{{item.address}}</p>
          <p>电话：{{item.telPhone}}</p>
        </li>
      </ul>
      <h2 class="loadmore pt30" :class="{ cursorp: moremap }" v-if="loadMore" @click="loadMorefun">{{ moremap === true ? '查看更多' : '已显示全部' }}</h2>
      <h2 class="nodata pt30" v-if="noData">暂无数据</h2>
    </div>
    <div class="infoBox" ref="infoBox" v-show="infoDetailflag">
      <div>
        <swiper class="swiper" ref="mySwiper" :options="swiperOption" v-if="infoDetail.banners">
          <swiper-slide class="swiper-slide" v-for="(banner, index) in infoDetail.banners" @click.stop="bannerlink(banner)" :key="index">
            <img :src="banner">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="contentbox">
        <div class="innerbox">
          <div class="txtbox">
            <h2>{{infoDetail.title}}</h2>
            <p class="icon icon1">{{infoDetail.address}}</p>
            <p class="icon icon2">{{infoDetail.telPhone}}</p>
          </div>
          <div class="descbox" v-html="infoDetail.content"></div>
        </div>
        <div class="funbox">
          <ul>
            <li class="icon icon1" v-if="infoDetail.panUrl !== undefined && infoDetail.panUrl !== ''" @click="panurlfun(infoDetail.panUrl)"></li>
            <li class="icon icon2" @click="fnDaohang(infoDetail.coordinate, infoDetail.address)"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from '@/utils/AMap'
import RemoGeoLocation from '@/utils/remogeo'
import { getCultureMapList } from '@/api/culturemap/index'
import typeconfig from '@/components/typescreen/typeconfig'
import { getTypeList } from '@/api/typescreen/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'culturemap',
  meta: {
    showHeader: true
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  data () {
    return {
      Param: {
        page: 1,
        limit: 10,
        nodeId: this.$route.query.columnId,
        siteType: '',
        codes: '',
        departmentCode: this.$cookie.get('museumCode')
      },
      loadMore: false,
      noData: false,
      moremap: true,
      typeParam: {
        'dictParentCode': typeconfig['culturemap'].dictName,
        'menuId': this.$route.query.columnId
      },
      currentpositon: {
        address: '',
        lng: '',
        lat: '',
        status: ''
      },
      // 地图类型选择
      mapnavValue: [],
      // cascader数组数据
      options: [],
      // 地图类型数据
      typeArr: [],
      // 地图标记点数据
      markerArr: [],
      markertotal: '',
      map: '',
      // 标记点详情
      infoDetail: [],
      // 标记点显示控制
      infoDetailflag: false,
      // 标记点详情轮播图
      swiperOption: {
        auotplay: true,
        pagination: {
          el: '.inforBox .swiper-pagination'
          // dynamicBullets: true
        }
      },
      dictTypeArr: [],
      keyValue: 0
    }
  },
  watch: {
    markertotal (val) {
      if (val) return val
    },
    mapnavValue (val) {
      // 监听值发生变化就关闭它
      if (this.$refs.mapnav) {
        this.$refs.mapnav.dropDownVisible = false
      }
    },
    $route (val) {
      if (val) {
        console.log(2)
        console.log(val)
      }
    },
    options (newVal) {
      this.keyValue++ // 只要监听到数据源发生变化 ，改变keyValue的值，达到重新渲染的效果
    }
  },
  created () {
  },
  mounted () {
    // 初始化地图类型
    this.mapnavValue = ['']
    // 初始化地图
    AMap.init().then(() => {
      this.getAMap() // 高德地图获取定位信息
    }, error => {
      console.log('地图加载失败', error)
    })
    this.$nextTick(() => {
      console.log(document.querySelector('#footer'))
      console.log(document.querySelector('#footer').height)
    })
    this.getTypeList()
  },
  methods: {
    // 递归方法
    getTreeData (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children)
        }
      }
      return data
    },
    loadMorefun () {
      let PageTotal = Math.ceil(this.markertotal / this.Param.limit)
      if (this.Param.page < PageTotal) {
        this.Param.page++
        this.getList()
      }
    },
    getList () {
      getCultureMapList(this.Param).then(res => {
        if (res.data.status === 200) {
          if (res.data.data.total > 0) {
            this.noData = false
            this.loadMore = true
            this.markertotal = res.data.data.total
            let PageTotal = Math.ceil(this.markertotal / this.Param.limit)
            if (this.Param.page === PageTotal) {
              this.moremap = false
            } else {
              this.moremap = true
            }
            for (let i in res.data.data.rows) {
              res.data.data.rows[i].hide = false
            }
            if (this.Param.page === 1) {
              this.markerArr = res.data.data.rows
            } else {
              this.markerArr = this.markerArr.concat(res.data.data.rows)
            }
          } else {
            this.noData = true
            this.loadMore = false
            this.markerArr = []
          }
          console.log(this.markerArr)
          this.createMarker(this.markerArr)
        }
      })
    },
    // cascader数据处理
    getTypeList () {
      getTypeList(this.typeParam).then((res) => {
        if (res.data.status === 200) {
          let typearr = []
          if (res.data.data.customType.length > 0) {
            let customTypechildren = this.getTreeData(res.data.data.customType[0].children)
            let customobj = {
              name: res.data.data.customType[0].name,
              id: res.data.data.customType[0].id,
              children: customTypechildren
            }
            typearr.push(customobj)
          }
          if (res.data.data.dictType.whdtcdlx.list.length > 0) {
            console.log(1)
            res.data.data.dictType.whdtcdlx.list.forEach((item, index) => {
              item.name = item.dictName
              item.id = index
            })
            let dictobj = {
              name: '站点类型',
              id: 0,
              children: this.getTreeData(res.data.data.dictType.whdtcdlx.list)
            }
            typearr.push(dictobj)
            this.dictTypeArr = res.data.data.dictType.whdtcdlx.list
            this.dictTypeArr.unshift({ 'name': '全部', id: '' })
          }
          console.log(typearr)
          this.options = typearr
        }
      })
    },
    handleChange (value) {
      console.log(value)
      this.Param.page = 1
      if (value[1] !== '') {
        let currentindex = parseInt(value[1]) + 1
        this.Param.siteType = this.dictTypeArr[currentindex].dictCode
      } else {
        this.Param.siteType = ''
      }
      this.getList()
    },
    // 初始化地图
    getAMap () {
      let _this = this
      this.map = new window.AMap.Map('container', {
        resizeEnable: true,
        zoom: 11
      })
      if (this.map) this.getList()
      window.AMap.plugin('AMap.Geolocation', function () {
        const geolocation = new window.AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          buttonOffset: new window.AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: false, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          panToLocation: false,
          showMarker: false, // 定位成功后在定位到的位置显示点标记，默认：true
          buttonPosition: 'RB'
        })
        // 判断是否是ios系统，如果是，则调用远程定位方法
        if (window.AMap.UA.ios) {
          // 使用远程定位，见 remogeo.js
          let remoGeo = new RemoGeoLocation()

          // 替换方法
          navigator.geolocation.getCurrentPosition = function () {
            return remoGeo.getCurrentPosition.apply(remoGeo, arguments)
          }

          // 替换方法
          navigator.geolocation.watchPosition = function () {
            return remoGeo.watchPosition.apply(remoGeo, arguments)
          }
        }
        _this.map.addControl(geolocation)
        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            onComplete(result)
          } else {
            onError(result)
          }
        })
      })

      // 解析定位结果
      function onComplete (data) {
        console.log(data)
        let geocoder = new window.AMap.Geocoder({
          city: '010', // 城市设为北京，默认：“全国”
          radius: 1000 // 范围，默认：500
        })
        geocoder.getAddress(data.position.toString().split(','), function (status, result) {
          if (status === 'complete' && result.regeocode) {
            // _this.dialogVisible = true
            _this.currentpositon.address = result.regeocode.formattedAddress
            _this.status = '定位成功'
            _this.currentpositon.lng = data.position.lng
            _this.currentpositon.lat = data.position.lat
          } else {
            alert('根据经纬度查询地址失败')
          }
        })
      }

      // 解析定位错误信息
      function onError (data) {
        console.log(data)
        _this.dialogVisible = true
        _this.status = '定位失败'
        // this.$refs.result.innerHTML = '失败原因排查信息:' + data.message
      }
    },
    // 初始化标记点
    createMarker (data) {
      this.map.clearMap()
      console.log(data)
      let points = data
      if (points.length === 0) {
        this.$message({
          message: '当前分类下没有站点！',
          type: 'warning',
          duration: 2000
        })
      }
      let marker = null
      for (let i in points) {
        let point = points[i]
        let Icon = ''
        if (point.icon !== undefined && point.icon !== '') {
          Icon = point.icon
        } else {
          Icon = require('../../assets/common/icon/icon-mapaddress.png')
        }
        let pointposition = point.coordinate.split(',')
        marker = new window.AMap.Marker({
          title: point.title,
          icon: Icon,
          position: [pointposition[0], pointposition[1]]
        })
        marker.setMap(this.map)
        marker.sid = point.id
        // 设置分类ID
        marker.cid = point.cid
        marker.on('click', this.markerClickHandler)
      }
      this.map.setFitView()
      this.map.getCenter()
      this.map.zoomOut()
    },
    markerClickHandler (ev) {
      this.fnInitSiteInfo(ev.target)
    },
    listpoint (val) {
      let currentTarget = this.getLastClickMarker(val.id)
      this.fnInitSiteInfo(currentTarget)
    },
    getLastClickMarker (markerId) {
      let markerArr = this.map.getAllOverlays('marker')
      let reMarker = ''
      for (let i in markerArr) {
        let m = markerArr[i]
        if (m.sid === markerId) {
          reMarker = m
          break
        }
      }
      return reMarker
    },
    fnInitSiteInfo (target) {
      this.infoDetail = {}
      for (let i in this.markerArr) {
        if (this.markerArr[i].id === target.sid) {
          this.infoDetail = this.markerArr[i]
          let banners = []
          let images = this.markerArr[i].image
          if (images !== undefined && images !== '') {
            if (images.indexOf('|') >= -1) {
              banners = images.split('|')
            } else {
              banners[0] = images
            }
          } else {
            banners[0] = require('@/assets/common/images/default.png')
          }
          this.infoDetail.banners = banners
          let infocontent = this.$refs.infoBox
          this.map.setCenter(target.getPosition())
          let infoWindow = new window.AMap.InfoWindow({
            isCustom: true,
            closeWhenClickMap: true,
            content: infocontent,
            offset: new window.AMap.Pixel(10, -20)
          })
          infoWindow.open(this.map, target.getPosition())
          this.infoDetailflag = true
          // this.map.setStatus({zoomEnable:false})
          // infoWindow.on('close', function(){
          //   this.map.setStatus({zoomEnable:true})
          // })
        }
      }
    },
    bannerlink (item) {
      console.log(item)
    },
    panurlfun (val) {
      window.open(val)
    },
    fnDaohang (postion, address) {
      if (this.currentpositon.lng === undefined || this.currentpositon.lat === undefined) {
        this.$message.error('无法定位您的位置，请稍后使用导航或重新手动定位后使用！')
      } else {
        let currentP = postion.split(',')
        let url = 'http://uri.amap.com/navigation?from=' + this.currentpositon.lng + ',' + this.currentpositon.lat + ',当前位置&to=' + currentP[0] + ',' + currentP[1] + ',' + address + '&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0'
        window.open(url)
      }
    },
    geticon (val) {
      if (val !== undefined && val !== '') {
        return 'url(' + val + ')'
      }
    }
  }
}
</script>

<style lang="scss">
.generalmapcontainer{
  padding: 56px 0 48px;
  .loadmore{
    padding-bottom: 100px;
  }
  #container{
    width: 100%;
    position: fixed;
    top: 56px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
  }
  .floatDivBoxs{
    position: fixed;
    top: 56px;
    left: 0;
    bottom: 0;
    z-index: 11;
    width: 300px;
    background: rgba(244, 244, 244, 0.9);
    padding: 61px 0 0;
    overflow: hidden;
    overflow-y: auto;
    .titlebox{
      padding: 20px 25px;
      cursor: pointer;
      h2{
        border: solid 1px #c4c4c4;
        height: 40px;
        border-radius: 10px;
        line-height: 40px;
        font-size: 16px;
        text-align: center;
        span{
        }
      }
    }
    .el-cascader{
      height: 61px;
      position: fixed;
      top: 56px;
      left: 0;
      width: 300px;
      padding: 20px 25px 0;
      display: block;
      .el-input{
        .el-input__inner{
          border: solid 1px #c4c4c4;
          border-radius: 10px;
          text-align: center;
          font-size: 16px;
        }
      }
    }
    ul{
      width: 90%;
      li{
        padding: 22px 0 22px 25px;
        border-bottom: solid 1px #d7d7d7;
        cursor: pointer;
        h2{
          padding: 0 0 0 40px;
          font-size: 16px;
          line-height: 26px;
          min-height: 40px;
          background: url('../../assets/common/icon/icon-mapaddress.png');
          background-repeat: no-repeat;
          background-position: left top;
          background-size: 20px;
        }
        p{
          max-height: 44px;
          font-size: 12px;
          line-height: 22px;
        }
        &:last-child{
          border-bottom: none;
        }
      }
    }
  }
  .infoBox{
    width: 700px;
    padding: 0 0 35px;
    position: relative;
    background: rgba(255,255,255,1);
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0,0,0,0.15);
    z-index: 9999;
    .swiper-container{
      height: 290px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      overflow: hidden;
      position: relative;
      z-index: 1;
      .swiper-slide{
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .contentbox{
      position: relative;
      z-index: 2;
      .innerbox{
        max-height: 320px;
        padding: 35px 35px 0;
        overflow-y: auto;
        .txtbox{
          border-bottom: solid 1px #eee;
          padding: 0 0 10px;
          h2{
            font-size: 24px;
            font-weight: bold;
            margin: 0 0 15px 0;
          }
          p{
            color: #666;
            line-height: 26px;
            padding: 0 6px 0 30px;
            &.icon1{
              background: url('../../assets/common/icon/icon-address.png') no-repeat;
              background-position: left 3px;
            }
            &.icon2{
              background: url('../../assets/common/icon/icon-telphone.png') no-repeat;
              background-position: left 3px;
            }
          }
        }
        .descbox{
          padding: 10px 0;
          color: #666;
          line-height: 24px;
        }
      }
      .funbox{
        position: absolute;
        top: -35px;
        right: 45px;
        z-index: 10;
        ul{
          li{
            width: 70px;
            height: 70px;
            float: left;
            margin: 0 0 0 15px;
            border-radius: 50%;
            box-shadow: 0 0 28px rgba(0,0,0,0.15);
            cursor: pointer;
            &.icon1{
              background: url('../../assets/common/icon/icon-map360.png') no-repeat;
              background-size: 100% 100%;
            }
            &.icon2{
              background: url('../../assets/common/icon/icon-mapposition.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1440px){
    .infoBox{
      padding: 0 0 25px 0;
      width: 450px;
      .swiper-container{
        height: 200px;
      }
      .contentbox{
        .innerbox {
          max-height: 210px;
          padding: 25px 25px 0;
          .txtbox{
            h2{
              font-size: 20px;
            }
          }
        }
        .funbox{
          top: -30px;
          right: 30px;
          ul{
            li{
              width: 60px;
              height: 60px;
            }
          }
        }
      }
    }
  }
}
.maptype{
  left: 25px!important;
  border-radius: 8px;
  border: none;
  .el-cascader-panel{
    .el-scrollbar{
      &:first-child{
        width: 250px;
        /*color: #0da78f;*/
      }
      .el-cascader-menu__wrap{
        max-height: 360px;
        min-height: 200px;
      }
    }
    .el-radio{
      width: 100%;
      height: 100%;
      z-index: 10;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .el-radio__input {
      visibility: hidden;
    }
    .el-cascader-node__postfix {
      top: 10px;
    }
    .el-cascader-node{
      &.in-active-path{
        color: #333;
      }
      &.is-active{
        color: #0da78f;
      }
      &.is-selectable{
        &.in-checked-path{
          color: #0da78f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/culturemap/list.vue